export const educationData = [
  {
    id: 1,
    institution: "Cairo University",
    course: "Software Engineering",
    startYear: "2022",
    endYear: "2023",
  },
  {
    id: 2,
    institution: "Helwan University",
    course: "Social work (Psychologist)",
    startYear: "2015",
    endYear: "2021",
  },

  //   {
  //     id: 3,
  //     institution: "Somerset School of Science",
  //     course: "Bachelor of Technology",
  //     startYear: "2015",
  //     endYear: "2019",
  //   },
];